export const configuredOriginRedirect = (currentUrl: string, configuredOrigin: string, production: boolean) => {
  if (!production || !configuredOrigin) return null;
  const current = new URL(currentUrl);
  const targetOrigin = configuredOrigin.replace(/\/$/, "");
  const target = new URL(targetOrigin);
  if (!current.hostname.endsWith(".pages.dev") || current.hostname === target.hostname) return null;
  return `${targetOrigin}${current.pathname}${current.search}${current.hash}`;
};
